export const palette = {
  space: {
    deep: 0x0a0c28,
    mid: 0x141838,
    far: 0x1e2350,
    nebula: 0x3b2e64
  },
  star: {
    warm: 0xfff1d6,
    cool: 0xd5dfff,
    soft: 0xffffff,
    gold: 0xffe2a0,
    pink: 0xffd3e0
  },
  planets: {
    mint: {
      base: 0xbde6c6,
      accent: 0x7dc996,
      detail: 0x3f8f6a,
      halo: 0xc4f0d3,
      clouds: 0xf6fffb
    },
    peach: {
      base: 0xffd1b8,
      accent: 0xf79e78,
      detail: 0xc45f42,
      halo: 0xffd9c4,
      clouds: 0xfff0e4
    },
    lavender: {
      base: 0xcfbbf0,
      accent: 0x9a86d4,
      detail: 0x5b4a96,
      halo: 0xe1d1f7,
      clouds: 0xf4ecff
    },
    butter: {
      base: 0xfdf6ae,
      accent: 0xe8c96d,
      detail: 0xb08a2a,
      halo: 0xfff5c1,
      clouds: 0xfffbe6
    },
    rose: {
      base: 0xf4b8c3,
      accent: 0xd47f93,
      detail: 0x8a3c55,
      halo: 0xfccdd6,
      clouds: 0xffe4eb
    }
  },
  station: {
    hull: 0xe5e2d4,
    hullMid: 0xb3aea0,
    hullDark: 0x3d3a45,
    trim: 0x2a2838,
    accent: 0xd65a3a,
    window: 0xffd389,
    panel: 0x7f9ad1,
    panelGlow: 0xb4d0ff,
    glow: 0xffb568,
    entry: 0x9cdcff
  },
  asteroid: {
    body: 0x8684a6,
    accent: 0x5f5d80,
    warm: 0xa8947e,
    crystal: 0x8dd1e6
  },
  ship: {
    hull: 0xebe6d8,
    hullDark: 0x6e6256,
    primary: 0xd43a3a,
    primaryDark: 0x841e1e,
    accent: 0xf2c048,
    cockpit: 0x0c0d1a,
    cockpitGlow: 0x5a82c4,
    glow: 0x9cdcff,
    plasma: 0x6ab6ff,
    trim: 0x2a2838,
    strobe: 0xff7a7a
  },
  light: {
    ambient: 0xc9d0ff,
    key: 0xfff0d6,
    rim: 0x9fb0ff,
    fillWarm: 0xffc9a0
  }
} as const;
